/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateConversationRequest } from '../models/CreateConversationRequest';
import type { SendConversationMessageRequest } from '../models/SendConversationMessageRequest';
import type { SuccessCreateConversationResponse } from '../models/SuccessCreateConversationResponse';
import type { SuccessPageConversationMessageResponse } from '../models/SuccessPageConversationMessageResponse';
import type { SuccessPageConversationResponse } from '../models/SuccessPageConversationResponse';
import type { SuccessVoid } from '../models/SuccessVoid';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConversationControllerService {

    /**
     * List conversations for the authenticated user
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns SuccessPageConversationResponse OK
     * @throws ApiError
     */
    public static listConversations(
        page?: any,
        size?: any,
        sort?: any,
    ): CancelablePromise<SuccessPageConversationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/conversations',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Create a new conversation
     * @param requestBody
     * @returns SuccessCreateConversationResponse OK
     * @throws ApiError
     */
    public static createConversation(
        requestBody: CreateConversationRequest,
    ): CancelablePromise<SuccessCreateConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/conversations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * List messages for a conversation
     * @param conversationId
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns SuccessPageConversationMessageResponse OK
     * @throws ApiError
     */
    public static listConversationMessages(
        conversationId: string,
        page?: any,
        size?: any,
        sort?: any,
    ): CancelablePromise<SuccessPageConversationMessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/conversations/{conversationId}/messages',
            path: {
                'conversationId': conversationId,
            },
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Send a message in a conversation
     * @param conversationId
     * @param requestBody
     * @returns SuccessVoid OK
     * @throws ApiError
     */
    public static sendMessage(
        conversationId: string,
        requestBody: SendConversationMessageRequest,
    ): CancelablePromise<SuccessVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/conversations/{conversationId}/messages',
            path: {
                'conversationId': conversationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
